module.exports = __webpack_public_path__ + "static/media/options-outline.6072e445.svg";